import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import config from "../../config";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";

// New page — the verification email's link points at
// http://localhost:3000/verify-email?token=... (a frontend URL). Nothing
// previously existed to render at that path, so clicking the link just hit
// React Router's catch-all and went nowhere. This page reads the token off
// the URL, calls GET /api/auth/verify-email (also newly wired up in
// authRoutes.js), and shows the result.
const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const [status, setStatus] = useState("verifying"); // 'verifying' | 'success' | 'error'
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("This verification link is missing its token.");
      return;
    }

    axios
      .get(`${config.baseURL}/api/auth/verify-email`, { params: { token } })
      .then((response) => {
        setStatus("success");
        setMessage(response.data.message || "Your email has been verified.");
      })
      .catch((err) => {
        setStatus("error");
        setMessage(
          err.response?.data?.message ||
            "This verification link is invalid or has expired."
        );
      });
  }, [token]);

  return (
    <>
      <Header />
      <section className="login-part">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="login-box text-center">
                {status === "verifying" && (
                  <>
                    <div className="login-title">Verifying your email…</div>
                    <p>Just a moment.</p>
                  </>
                )}

                {status === "success" && (
                  <>
                    <div className="login-title">Email verified!</div>
                    <p>{message}</p>
                    <button
                      type="button"
                      className="btn-filled"
                      onClick={() => navigate("/login")}
                    >
                      Go to login
                    </button>
                  </>
                )}

                {status === "error" && (
                  <>
                    <div className="login-title">Verification failed</div>
                    <p style={{ color: "#B3261E" }}>{message}</p>
                    <p>
                      <Link to="/login">Back to login</Link>
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default VerifyEmail;